import { EVAL_TENANT_ID } from '@terra/api-common-constants';
import { hasEvaluationExecutePermission } from './evaluation-execute-permission';

export type EvaluationSourceTenantAccessInput = {
  tenantId: string;
  currentTenant: string | null;
  currentPermissions: readonly string[];
  isTerraUser: boolean;
};

export class EvaluationTenantAccessError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'EvaluationTenantAccessError';
  }
}

export function assertEvaluationSourceTenantAccess({
  tenantId,
  currentTenant,
  currentPermissions,
  isTerraUser,
}: EvaluationSourceTenantAccessInput): void {
  if (tenantId === EVAL_TENANT_ID) {
    return;
  }
  if (isTerraUser) {
    return;
  }
  if (currentTenant && tenantId === currentTenant) {
    return;
  }
  if (
    !hasEvaluationExecutePermission({
      permissions: currentPermissions,
    })
  ) {
    throw new EvaluationTenantAccessError(
      'Evaluation Execute permission is required to access another tenant’s evaluation data',
    );
  }
}
